import { Button } from '@vrplatform/components';
import { useDashboard } from '@vrplatform/data';
import { parseAsBoolean, useQueryState } from '@vrplatform/query-params';
import { ListingMappingModal } from './ListingMappingModal';

export const ListingsMappingButton = () => {
  const [dashboard] = useDashboard();
  const [o, setOpened] = useQueryState('listing-mapping', parseAsBoolean);
  const opened = !!o;

  const openModal = () => setOpened(true);
  const closeModal = () => setOpened(false);

  if (!['propertyManager', 'admin'].includes(dashboard)) return null;

  return (
    <>
      <Button variant="transparent" leftIcon={'Link2Icon'} onClick={openModal}>
        Link Units
      </Button>
      <ListingMappingModal
        opened={opened}
        closeModal={closeModal}
        openModal={openModal}
      />
    </>
  );
};
